;
(function(){
    $(document).on('click', '.grocerystore__item-container', function(e) {
        var $target = $(e.target).closest('.grocerystore__item-container');
        if ( $target.hasClass('selected') ) {
            $target.removeClass('selected');
            $('input', $target).attr('checked', null);
        } else {
            $('input', $target).attr('checked', 'checked');
            $target.addClass('selected');
        }
    });
})();